export default __webpack_public_path__ + "static/media/designkit.7a462623.svg";